<template>
  <breadcrumb :links="links"></breadcrumb>

  <div class="container-xl p-0 py-sm-2 px-sm-3">
    <div id="content_container">
      <div id="sidebar" v-if="showSidebar">
        <h4 class="text-center mt-4">Terremoti</h4>
        <div class="p-4">
          <p>I dati epicentrali riportati derivano dalla localizzazione automatica del sistema di sorveglianza sismica
            Antelope, gestito da DMG-UNITS e dai sistemi del CRS-OGS.</p>
        </div>
        <div class="sensor_links">
          <a :class="'sensor_link' + (what == 'l50' ? ' active' : '')" v-on:click="loadEarthquakes('l50')">
            Ultimi 50 eventi
          </a>
          <a :class="'sensor_link' + (what == 'd5' ? ' active' : '')" v-on:click="loadEarthquakes('d5')">
            Ultimi 5 giorni
          </a>
          <a :class="'sensor_link' + (what == 'd10' ? ' active' : '')" v-on:click="loadEarthquakes('d10')">
            Ultimi 10 giorni
          </a>
          <a :class="'sensor_link' + (what == 'd20' ? ' active' : '')" v-on:click="loadEarthquakes('d20')">
            Ultimi 20 giorni
          </a>
          <a :class="'sensor_link' + (what == 'm3' ? ' active' : '')" v-on:click="loadEarthquakes('m3')">
            Magnitudo > 3
          </a>
        </div>
        <div class="map_legend">
          <Legend v-if="legend != undefined" :legend="this.legend">
          </Legend>
        </div>
      </div>
      <button class="btn btn-light button" id="close_sidebar" v-on:click="showSidebar = false; showXButton = false"
        v-if="showXButton">
        <i class="bi bi-x-lg p-2"></i>
        <span class="text-color">Terremoti</span>
      </button>
      <div id="map_container">
        <button v-if="!this.showSidebar" id="show_sidebar" class="btn btn-light button"
          v-on:click="showSidebar = true; showXButton = true">
          <i class="bi bi-list p-2"></i>
          <span class="text-color">Legenda</span>
        </button>
        <Map class="map" :markers="mapMarkers" :currentSensor="current">
          <template #popup="{ item }">
            <template v-if="item.get">
              <p class="text-primary fw-bold text-center">{{ convertTime(item.get('date')) }}</p>
              <p class="text-center">{{ item.get('description') }}</p>
              <p class="text-center">Magnitudo: <span class="text-primary">{{ item.get('magnitudo') }}</span></p>
              <p class="text-center">Magnitudo: <span class="text-primary">{{ item.get('depth') }}</span> km</p>
            </template>
          </template>
        </Map>
      </div>
    </div>
  </div>

  <app-footer-mini></app-footer-mini>
</template>

<script>
import Map from '@/components/Map/BaseFvgMap';
import Legend from '@/components/Legend';
import MonitorApi from '@/services/MonitorApi';
import Labels from '@/utils/labels';
import AppFooterMini from '@/app-footer-mini.vue';
import Breadcrumb from '@/components/Breadcrumb';
import { v4 as uuidv4 } from 'uuid';
import { imageMarkerUI } from '@/components/Map/MapMarkers';

export default {
  components: { Map, Legend, AppFooterMini, Breadcrumb },
  mixins: [Labels],
  data: function () {
    return {
      loader: false,
      mapMarkers: [],
      showSidebar: true,
      what: 'l50',
      links: {
        '/': 'Home',
        'current': 'Terremoti'
      },
      legend: {
        title: "Magnitudo",
        units: "magnitudo",
        type: 'markers',
        markers: [{
          label: 'minore di 2',
          src: 'earthquake_0.png'
        }, {
          label: 'fra 2 e 3',
          src: 'earthquake_1.png'
        }, {
          label: 'fra 3 e 4',
          src: 'earthquake_2.png'
        }, {
          label: 'fra 4 e 5',
          src: 'earthquake_3.png'
        }, {
          label: 'maggiore di 5',
          src: 'earthquake_4.png'
        }]
      }
    }
  },
  methods: {
    toggleSidebar: function () {
      this.showSidebar = !this.showSidebar
    },
    loadEarthquakes: async function (what) {
      this.what = what;
      const earthquakes = await MonitorApi.getEarthquakes(this.what);
      this.mapMarkers = earthquakes.map(e => ({
        date: e.dt,
        lat: e.lat,
        lon: e.lon,
        description: e.description,
        magnitudo: e.magnitudo,
        depth: e.depth,
        icon: `${uuidv4()}`,
        ui: imageMarkerUI({ src: this.pointStyle(e.magnitudo) })
      }))
    },
    pointStyle: function (magnitudo) {
      const e_level =
        magnitudo > 5 ? 4 :
          magnitudo > 4 ? 3 :
            magnitudo > 3 ? 2 :
              magnitudo > 2 ? 1 :
                0;
      const icon = '/map_icons/earthquake_' + e_level + '.png';
      return icon;
    }
  },
  mounted: function () {
    this.showSidebar = false;
    this.loadEarthquakes('l50');
  }
}
</script>

<style lang="scss" scoped>
.text-color {
  padding: 10px;
  writing-mode: vertical-rl;
  text-orientation: sideways-right;
  transform: rotate(180deg);
  color: #0067b1;
}

.button {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: 50px;
  height: auto;
}

#close_sidebar {
  position: absolute;
  left: 200px;
  z-index: 1011;
  background-color: #fff;
  opacity: 0.8;
  font-variant: small-caps;
  font-weight: bold;
}

#content_container {
  position: relative;
  width: 100%;
  height: 100%;
}

#map_container {
  height: 100%;

  .map {
    height: 100%;
  }
}

#sidebar {
  z-index: 1015;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 200px;
  background-color: #fff;
  opacity: 0.8;
  overflow: auto;

  h4 {
    text-align: right;
    padding: 5px;
  }

  p {
    font-size: 14px;
    padding: 0 5px;
  }

  .sensor_links {
    margin-top: 10px;
    overflow: hidden;

    .sensor_link {
      display: block;
      text-align: center;
      cursor: pointer;
      text-decoration: none;
      color: #0067b1;
      font-variant: small-caps;
      font-weight: bold;
      font-size: 1.2em;
      padding-right: 5px;

      &:hover {
        background-color: #ccc;
      }

      span {
        display: inline-block;
        width: 70px
      }
    }

    .active {
      background-color: #0067b1;
      color: #fff;

      &:hover {
        color: #0067b1;
        background-color: #ccc;
      }
    }
  }
}

#show_sidebar {
  position: absolute;
  top: 10px;
  left: 0;
  z-index: 2000;
  font-variant: small-caps;
  font-weight: bold;
}

.map_legend {
  padding-top: 30px;
  background-color: #fff;
}
</style>